import EDDom from "../handler/EDDom.js"

export default class EDSpan extends EDDom {
    constructor(p) {
        p.tagName = "span"
        super(p)
    }
}